class AssertionError extends Error {}

function assert(condition: boolean, msg?: string): asserts condition {
  msg ??= 'unknown assertion error';

  if (!condition) {
    throw new AssertionError(msg);
  }
}

export { assert };
